import delay from '@/utils/time/delay';
import audio from '@/utils/medias/audio';

window.$audio = audio

export default {
  async alarm (args) {
    let dt = args.date_alarm
    if (typeof dt === 'object' && dt !== null) dt = dt.date_time
    dt = dt.replace("T", " ").replace('Z', '')
    const dt2 = new Date(dt), dt1 = new Date(new Date()), diff = Math.abs(dt2.getTime() - dt1.getTime()),
      btn = `alarm-${Math.random()}`;
    await delay(diff)
    $audio.alarm()
    return `<div class="my-2 font-weight-black">*** ALARME ***</div>
    <button id="${btn}" type="button" onclick="$audio.stop(); document.getElementById('${btn}').parentNode.removeChild(document.getElementById('${btn}'))" class="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--small error darken-2" title="desligar alarme">
    <span class="v-btn__content">
      <i aria-hidden="true" class="v-icon notranslate mr-1 mdi mdi-alarm theme--dark" style="font-size: 16px;"></i>
      <span class="ml-1">deligar alarme</span>
    </span></button>`

  },
  now (args) {
    let dt = new Date(),
      min = dt.getMinutes();
    min = (min != '00') ? ` e ${min} minutos` : '';
    return { msg: `Agora são ${dt.getHours()} horas ${min}` }
  },

}
